// extracted by mini-css-extract-plugin
module.exports = {"searchbarSocMedIcon":"socialMediaIcon-module--searchbarSocMedIcon--1OX8E"};